<template>
  <div class="layout">
    <Layout>
      <AdminHeader />
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <AdminLeftMenu />
          <div class="slider-sep"></div>
        </Sider>
        <Layout class="admin-right-wrap">
          <AdminContentBread />
          <!--页面内容主体开始-->
          <Content class="admin-wrap">
            <div>
              <Tabs value="searchName">
                <TabPane label="按姓名搜索" name="searchName">
                  <Row class="search-form">
                    <Col span="16" style="padding-right: 6px;"><Input enter-button="搜索" v-model="searchName" placeholder="输入姓名搜索..." /></Col>
                    <Col span="8"><Button type="primary" @click="searchMembersByName">搜索</Button></Col>
                  </Row>
                </TabPane>
                <TabPane label="按年龄段搜索" name="searchAge">
                  <Row class="search-form">
                    <Col span="8" style="padding-right: 6px;"><Input enter-button="搜索" v-model="searchAgeMin" placeholder="最小年龄..." /></Col>
                    <Col span="8" style="padding-right: 6px;"><Input enter-button="搜索" v-model="searchAgeMax" placeholder="最大年龄..." /></Col>
                    <Col span="8"><Button type="primary" @click="searchMembersByAge">搜索</Button></Col>
                  </Row>
                </TabPane>
                <TabPane label="按协会名称搜索" name="searchUnit">
                  <Input search enter-button="搜索" v-model="searchUnit" @on-search="searchMemberByUnit" placeholder="输入搜索内容..." />
                </TabPane>
              </Tabs>
            </div>
            <Table border :columns="tableColumns" :data="membersList" style="margin-top: 20px;">
              <template slot-scope="{ row }" slot="name">
                <strong>{{row.memberName}}</strong>
              </template>
              <template slot-scope="{ row }" slot="action">
                <ButtonGroup size="small">
                  <Button type="info" size="small" @click="show(row)">查看</Button>
                </ButtonGroup>
              </template>
            </Table>
            <div class="admin-list-pager">
              <Page :total="membersNum" show-elevator show-total @on-change="pageChaged" />
            </div>
          </Content>
          <!--页面内容主体结束-->
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import axios from "axios"
import AdminLeftMenu from '@/components/AdminLeftMenu.vue'
import AdminContentBread from '@/components/AdminContentBread.vue'
import AdminHeader from '@/components/AdminHeader.vue'
export default {
  components: {
    AdminLeftMenu,
    AdminContentBread,
    AdminHeader
  },

  //数据
  data() {
    return {
      token: '',
      searchName: '',
      searchAgeMin: 0,
      searchAgeMax: 0,
      searchUnit: '',
      page: 1,
      status: 1,
      //搜索类型 1姓名 2年龄
      searchType: 1,
      membersNum: 0,
      membersList: [],
      tableColumns: [
        {
          title: '姓名',
          slot: 'name',
          width: 126
        },
        {
          title: '性别',
          key: 'gender',
          width: 80,
          align: 'center'
        },
        {
          title: '职称',
          key: 'memberTitle',
          width: 126
        },
        {
          title: '电话',
          key: 'memberTel',
          width: 136
        },
        {
          title: '生日',
          key: 'birthday',
          width: 116
        },
        {
          title: '工作单位',
          key: 'workunit'
        },
        {
          title: '操作',
          slot: 'action',
          width: 170,
          align: 'center'
        }
      ],
    }
  },

  //加载后执行
  mounted() {
    //初始化页面数据
    this.initAuthData()
  },
  
  //自定义函数
  methods: {
    //初始化页面基础信息
    initAuthData() {
      let admin = JSON.parse(localStorage.getItem("adminInfo"));
      if(admin!=null) {
        this.token = admin.token
      }
    },

    //会员姓名搜索
    searchMembersByName() {
      let vm = this
      vm.searchType = 1;
      if(vm.searchName=="") {
        this.$Message.error('请您输入搜索内容');
        return;
      }
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/members/list-for-name-search",
        {key: vm.searchName, page: vm.page, status: 1},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let info = res.data
        vm.membersList = info.data.list
        vm.membersNum = info.data.num
      }).catch(function(error) {
        console.log(error)
      });
    },

    //会员按照年龄搜索
    searchMembersByAge() {
      let vm = this
      vm.searchType = 2;
      
      let minAge = parseInt(vm.searchAgeMin)
      let maxAge = parseInt(vm.searchAgeMax)

      if(isNaN(minAge) || isNaN(maxAge) || (minAge >= maxAge) || minAge<=40 || maxAge>100 ) {
        this.$Message.error('年龄区间为40到100之间的整数');
        return;
      }
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/members/list-for-age-search",
        {minAge:minAge, maxAge: maxAge, page: vm.page, status: 1},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let info = res.data
        vm.membersList = info.data.list
        vm.membersNum = info.data.num
      }).catch(function(error) {
        console.log(error)
      });

    },

    //按照协会名称搜索
    searchMemberByUnit() {
      let vm = this
      vm.searchType = 3;
      if(vm.searchUnit=="") {
        this.$Message.error('请您输入搜索内容');
        return;
      }
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/members/list-for-unit-search",
        {key: vm.searchUnit, page: vm.page, status: 1},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let info = res.data
        vm.membersList = info.data.list
        vm.membersNum = info.data.num
      }).catch(function(error) {
        console.log(error)
      });
    },

    //翻页
    pageChaged(page) {
      this.page = page
      switch (this.searchType) {
        case 1:
          this.searchMembersByName()
          break
        case 2:
          this.searchMembersByAge()
          break
        case 3:
          this.searchMemberByUnit()
          break
      }
    },

    //查看会员
    show(item) {
      window.open(this.$router.resolve({ path: '/manage/members/show', query: { id: item.memberId }}).href)
    },

  }
}
</script>